/** Resolves a clock-picked time to the next matching wall-clock instant from nowMs, rolling past midnight into tomorrow. */
export function getWallTimeFromClockDate(nowMs: number, selectedDate: Date): Date | null {
    if (Number.isNaN(selectedDate.getTime())) return null;

    const target = new Date(nowMs);
    target.setHours(selectedDate.getHours(), selectedDate.getMinutes(), 0, 0);

    if (target.getTime() <= nowMs) {
        target.setDate(target.getDate() + 1);
    }

    return target;
}

export function isSameClockMinute(nowMs: number, selectedDate: Date): boolean {
    const now = new Date(nowMs);
    return selectedDate.getHours() === now.getHours() && selectedDate.getMinutes() === now.getMinutes();
}
